// extracted by mini-css-extract-plugin
export default {"customScroll":"scrollbar_customScroll__pcL2o","customScrollLight":"scrollbar_customScrollLight__qYabH"};